import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSiteSettings } from './SiteSettingsContext';
import { isExternalHeroActionPath, normalizeHeroActionPath } from './storefrontHeroActions';

function isAnnouncementEnabled(settings) {
  const v = settings?.announcement_enabled;
  return v === true || v === 1 || v === '1';
}

/**
 * Shopify-style utility strip — full width, above the main header (site-wide).
 */
export default function HomeAnnouncementBar() {
  const { settings } = useSiteSettings();
  const { pathname } = useLocation();

  if (pathname.startsWith('/admin')) return null;
  if (!isAnnouncementEnabled(settings)) return null;

  const text = String(settings.announcement_text || '').trim();
  if (!text) return null;

  const link = normalizeHeroActionPath(settings.announcement_link);
  const message =
    link && !isExternalHeroActionPath(link) ? (
      <Link to={link} className="site-announcement-bar__message">
        {text}
      </Link>
    ) : link ? (
      <a href={link} className="site-announcement-bar__message" target="_blank" rel="noopener noreferrer">
        {text}
      </a>
    ) : (
      <span className="site-announcement-bar__message">{text}</span>
    );

  return (
    <div className="site-announcement-bar" role="region" aria-label="Store announcement">
      <div className="site-announcement-bar__inner">{message}</div>
    </div>
  );
}
